// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K944","col":"styles_col__1J7ae"};